import { useEffect } from 'react';
import { TABLE_PAGINATION_PIN_EVENT } from '../constants';
export default function useAddEventListeners({ handleDrag, handleDragEnd, handleVerticalScroll }) {
    useEffect(() => {
        document.addEventListener('mousemove', handleDrag);
        document.addEventListener('mouseup', handleDragEnd);
        window.addEventListener('scroll', handleVerticalScroll, { passive: true });
        document.addEventListener(TABLE_PAGINATION_PIN_EVENT, handleVerticalScroll);
        return () => {
            document.removeEventListener('mousemove', handleDrag);
            document.removeEventListener('mouseup', handleDragEnd);
            window.removeEventListener('scroll', handleVerticalScroll);
            document.removeEventListener(TABLE_PAGINATION_PIN_EVENT, handleVerticalScroll);
        };
    }, [handleDrag, handleDragEnd, handleVerticalScroll]);
}
